// extracted by mini-css-extract-plugin
export default {"newContainer":"LoginScreen_newContainer__JGPdt","container":"LoginScreen_container__-Xhrk"};